export enum CallQueueType {
    DIRECT_AGENT_GROUP = 'DirectAgentGroup',
    CALL_QUEUE = 'CallQueue',
    AGENT = 'Agent'
}

// Sentinel agent id sent to the backend when selected Direct Agent Group(s) have
// no member agents, so an empty agentIds array isn't mistaken for "no filter".
export const EMPTY_AGENT_ID = '00000000-0000-0000-0000-000000000000';

// TCX-6501: sentinel queue id sent to the backend when a Manager has zero assigned call queues, so
// an empty queueIds array isn't mistaken for "no filter" (same reserved value as EMPTY_AGENT_ID —
// queue ids and agent ids are validated independently server-side, so reuse carries no collision risk).
export const EMPTY_QUEUE_ID = '00000000-0000-0000-0000-000000000000';